<template>
  <owal-modal-panel
    title="Dismiss Elopement Alert"
    :bottom-buttons="bottomButtons"
  >
    <div
      class="owal-elopement-alerts__input"
    >
      <label>Confirm your PIN to proceed:</label>
      <!-- Warning: Automatically focusing a form control can confuse visually-impaired people using
      screen-reading technology. When autofocus is assigned, screen-readers "teleport" their user to the
      form control without warning them beforehand. https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input-->
      <input
        :tabindex="-1"
        autofocus
        ref="pinInput"
        type="tel"
        class="conceal-circle"
      >
    </div>
  </owal-modal-panel>
</template>

<script>
import { OwalModalPanel } from '@/libraries/owal-ui/'
import { dismissAlertWithPin } from '@/libraries/api/facesAlerts'
import { hashPINForTransmission } from '@/libraries/api/userPin'

export default {
  name: 'ElopementAlertDismissModal',
  components: {
    OwalModalPanel,
  },
  props: {
    /**
     * @prop {Number} alertId The id of the alert to dismiss.
     * */
    alertId: {
      type: String,
      default: undefined,
    },
    /**
     * @prop {Boolean} usePin Determines if we use the "me" keyword or a pin number in the call to endpoint.
     */
    usePin: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    bottomButtons () {
      const buttons = [
        {
          identifier: 'cancel',
          title: 'Cancel', /*  */
          callback: this.cancel,
        },
        {
          identifier: 'dismiss',
          title: 'Confirm PIN',
          callback: this.dismiss,
        },
      ]
      return buttons
    },
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    },
    /**
     * Dismiss the alert and hide the pin modal.
     */
    dismiss () {
      const canDismiss = this.usePin
      const pin = canDismiss ? this.$refs.pinInput.value : undefined
      const hashedPin = canDismiss ? hashPINForTransmission(pin) : 'me'
      /**
       * Call server with alert Id and pin.
       * On response, emit a response to the presenting component..
       */
      dismissAlertWithPin(this.alertId, hashedPin)
        .then(response => response.data)
        .then(data => {
          if (data.ok) {
            this.$emit('did-dismiss', { success: true })
          } else if (!data.ok) {
            window.alert(data.error)
            this.$emit('did-dismiss', { success: false })
          }
        })
        .then(() => {
          this.cancel()
        })
    },
  },
}
</script>

<style>
.conceal-circle {
  font-family: 'text-security-disc';
}
</style>
